/* Art of Steam Co. — product page: "Will it fit?" check and compare buttons. Uses assets/aos-sizing.js. */
(function () {
  if (window.__aosProduct) return;
  window.__aosProduct = true;

  function S() { return window.AOS && window.AOS.sizing; }
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }

  function readRoom(box) {
    var r = {};
    box.querySelectorAll('input[name], select[name]').forEach(function (el) { r[el.name] = el.value; });
    return r;
  }
  function fillRoom(box) {
    var saved = S().loadRoom();
    box.querySelectorAll('input[name], select[name]').forEach(function (el) {
      if (saved[el.name] != null && saved[el.name] !== '' && !el.dataset.aosTouched) el.value = saved[el.name];
    });
  }

  function evaluate(det) {
    var s = S(); if (!s) return;
    var box = det.querySelector('.aos-fit'); var out = det.querySelector('.aos-fit__result');
    var r = readRoom(box);
    if (!(s.num(r.L) > 0 && s.num(r.W) > 0 && s.num(r.H) > 0)) { out.innerHTML = ''; out.className = 'aos-fit__result'; return; }
    var min = det.getAttribute('data-min'), max = det.getAttribute('data-max');
    var fit, line;
    if (det.getAttribute('data-fit') === 'heater') {
      var h = s.heater(r);
      fit = s.heaterFit(h.adjusted, min, max);
      line = 'Your room: ' + fmt(h.base) + ' cu. ft., adjusted to ' + fmt(h.adjusted) + ' cu. ft. for glass, insulation and ceiling. ' +
        'This heater is rated for ' + (s.num(min) > 0 ? fmt(min) + '–' : 'up to ') + fmt(max) + ' cu. ft.';
    } else {
      var key = s.brandKey(det.getAttribute('data-brand'));
      var st = s.steam(key, r);
      fit = s.steamFit(st, max);
      line = 'Your room: ' + fmt(st.base) + ' cu. ft.' + (Math.round(st.adjusted) !== Math.round(st.base) ? ', which needs a generator rated for at least ' + fmt(st.adjusted) + ' cu. ft. after ' + (key === 'thermasol' || key === 'kohler' ? 'the ceiling-height step-up' : 'wall material and ceiling height') : '') +
        '. This generator is rated up to ' + fmt(max) + ' cu. ft.';
    }
    var calc = det.getAttribute('data-fit') === 'heater' ? '/pages/sauna-sizing-calculator' : '/pages/steam-shower-generator-calculator';
    var msg = fit.message ? '<p class="aos-fit__note">' + fit.message + '</p>' : '';
    var extra = fit.status === 'small' || fit.status === 'big'
      ? '<p class="aos-fit__note">See which sizes fit in our <a href="' + calc + '">sizing calculator</a>, or email us your room details.</p>' : '';
    out.className = 'aos-fit__result aos-fit__result--' + fit.status;
    out.innerHTML = '<p class="aos-fit__verdict">' + (fit.label || '') + '</p><p>' + line + '</p>' + msg + extra;
  }

  function initFit(root) {
    (root || document).querySelectorAll('details[data-fit]').forEach(function (det) {
      if (det.__aos) return; det.__aos = true;
      fillRoom(det);
      evaluate(det);
    });
  }

  document.addEventListener('input', function (e) {
    var det = e.target.closest && e.target.closest('details[data-fit]');
    if (!det) return;
    e.target.dataset.aosTouched = '1';
    var s = S(); if (s) { var saved = s.loadRoom(); var r = readRoom(det); for (var k in r) saved[k] = r[k]; s.saveRoom(saved); }
    evaluate(det);
  });
  document.addEventListener('change', function (e) {
    var det = e.target.closest && e.target.closest('details[data-fit]');
    if (det) { var ev = new Event('input', { bubbles: true }); e.target.dispatchEvent(ev); }
  });

  // compare entries are "handle" or "handle|variantId", so the variant chosen on the page is the one compared
  function key(btn) { var v = btn.getAttribute('data-variant'); return btn.getAttribute('data-handle') + (v ? '|' + v : ''); }

  function syncCompare() {
    var c = window.AOS && window.AOS.compare; if (!c) return;
    document.querySelectorAll('[data-aos-compare]').forEach(function (btn) {
      var cat = btn.getAttribute('data-aos-compare'), h = key(btn);
      var on = c.has(cat, h);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? 'Added to compare ✓' : 'Add to compare';
      var link = btn.parentNode.querySelector('.aos-compare-link');
      var n = c.list(cat).length;
      if (link) { link.hidden = n < 1; link.textContent = 'View comparison (' + n + ')'; }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aos-compare]');
    if (!btn) return;
    var c = window.AOS && window.AOS.compare; if (!c) return;
    var ok = c.toggle(btn.getAttribute('data-aos-compare'), key(btn));
    if (!ok) { btn.textContent = 'Compare holds ' + c.max + ' — remove one first'; return; }
    syncCompare();
  });
  document.addEventListener('aos:compare-changed', syncCompare);

  function boot() { initFit(document); syncCompare(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // the theme swaps the variant block on variant change: re-initialise new nodes
  var queued = false;
  new MutationObserver(function (records) {
    if (queued) return;
    var relevant = records.some(function (r) { return [].some.call(r.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-block-type="aos-variant-details"], .aos-details') || n.querySelector && n.querySelector('details[data-fit], [data-aos-compare]')); }); });
    if (!relevant) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; initFit(document); syncCompare(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
